import { Component, input } from '@angular/core';
import { DsmDealOption } from '../../../models/dsm-deal-options-view.models';
import { DsmSignOffAddendumListComponent } from '../dsm-sign-off-addendum-list/dsm-sign-off-addendum-list.component';

@Component({
  selector: 'dsm-aps-sign-off-addendums',
  standalone: true,
  imports: [DsmSignOffAddendumListComponent],
  template: `
    <dsm-sign-off-addendum-list [addendums]="addendums()" emptyMessage="No addendums attached to this envelope." />
  `
})
export class DsmApsSignOffAddendumsComponent {
  readonly addendums = input.required<DsmDealOption[]>();
}
